export default __webpack_public_path__ + "static/media/live_banner_desktop.bac8dece.png";